import { Threads } from '@/screens/threads';

export default function ThreadsScreen() {
  return <Threads />;
}
